import {Component} from '@angular/core';
import {ProgressSpinner} from 'primeng/progressspinner';

@Component({
	selector: 'app-spinner',
	standalone: true,
	template: `
		<div class="flex p-3 justify-content-center align-items-center width-full height-full">
			<p-progress-spinner ariaLabel="loading"/>
		</div>
	`,
	imports: [
		ProgressSpinner
	],
	styles: []
})
export class SpinnerComponent {

}
